import React from 'react';
import { withRouter } from 'react-router-dom';

import {Modal, ModalHeader, ModalBody, ModalFooter} from 'Components/Modal';
import {PrimaryButton} from 'Components/Button';


class EventStart extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    handleGo = () => {
        localStorage.setItem('event-started', 'true');

        this.props.history.push('/main-stage');

        this.props.onClose();
    };

    render () {
        return (
            <Modal>
                <ModalHeader onClose={this.props.onClose}>
                    Live show is starting
                </ModalHeader>
                 <ModalBody>
                     <p className="text-center">
                        Head to Main Stage now
                     </p>
                 </ModalBody>

                <ModalFooter alignment="center">
                    <PrimaryButton
                        onClick={this.handleGo}
                        text="Go to Main Stage"
                    />
                </ModalFooter>
            </Modal>
        )
    }
}

export default withRouter(EventStart);
